module.exports = __webpack_public_path__ + "html/subscription-page_97d0b066bd3f5c2a6bd1c7ced2cecefe.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/subscription-page.html
// module id = VVFi
// module chunks = 54